import classNames from 'classnames';
import Icon from '../Icon';

import styles from './BrandLogo.module.scss';

/**
 * BrandLogo
 *
 * @return {JSX.Element}
 */
const BrandLogo = ({ className, animate }) => {
  return (
    <Icon
      className={classNames(
        styles.BrandLogo,
        animate && styles.BrandLogo__animate,
        className,
        `${BrandLogo.displayName}`
      )}
      name="logo_new"
    />
  );
  // return (
  //   <View
  //     className={classNames(
  //       styles.BrandLogo,
  //       className,
  //       `${BrandLogo.displayName}`
  //     )}
  //   >
  //     <Txt>Propa</Txt>
  //   </View>
  // );
};

BrandLogo.displayName = 'BrandLogo';

export default BrandLogo;
